export default __webpack_public_path__ + "static/media/creativityFestival1.ee816888.png";